import { HistoryEvent, HistoryEventParameters } from '@api/types';
import { nameStartsWith } from '@react/constants/historyEvent/utils';

class AppMigrationUpdater {
  check(event: HistoryEvent): boolean {
    return nameStartsWith(event, 'dashboard:mobile_app:migrated');
  }

  updateParams(params: HistoryEventParameters): void {
    params.newAccountName = params.new_account_name;
    params.oldAccountName = params.old_account_name;
  }
}

export const appMigrationUpdater = new AppMigrationUpdater();
